<template>
  <div>
    <div class="footerBar">
    <el-row>
      <el-col :span="4" :offset="3">
        <ul>
          <li class="liFirst">products</li>
          <li>products</li>
          <li>products</li>
          <li>products</li>
          <li>products</li>
        </ul>
      </el-col>
      <el-col :span="4">
        <ul>
          <li  class="liFirst">Company</li>
          <li>products</li>
          <li>products</li>
          <li>products</li>
          <li>products</li>
        </ul>
      </el-col>
      <el-col :span="4">
        <ul>
          <li  class="liFirst">Policies</li>
          <li>products</li>
          <li>products</li>
          <li>products</li>
          <li>products</li>
        </ul>
      </el-col>
      <el-col :span="6">
        <ul>
          <li  class="liFirst">{{$t("router.contact")}}</li>
          <li>Copyright © {{currentYear}} {{$t("footer.Copyright")}}</li>
          <li>{{$t("footer.add")}}</li>
          <li>{{$t("footer.tel")}}</li>
          <!-- <li>ICP备案号：粤ICP备14010311号-1</li>
          <li>技术支持：第七城市</li> -->
        </ul>
      </el-col>
    </el-row>
    </div>
    <p class="right">
      <span><a href="https://beian.miit.gov.cn/" target="blank">{{$t("footer.icp")}}</a></span>
      <span style="margin-left:30px"><a href="http://www.7-inc.com/" target="blank">{{$t("footer.it")}}</a></span>
    </p>
    <!-- <img src="@/assets/footer-bg.jpg"></img> -->
  </div>
  

</template>
  
  <script>
export default {
  name: "Footer",
  data() {
    return {
      currentYear:''
    };
  },
  methods: {},
  created(){
    let date = new Date();
    console.log(date);
    console.log(date.getFullYear());
    this.currentYear = date.getFullYear();
  }
};
</script>
  
  <style lang="less" scoped>
  a:hover{
    color: #fe696a;
  }
.footerBar {
  background-color: #373f50;
  height: 220px;
  ul {
    color: #FFFFFFa6;
    font-size: 12px;
    li {
      margin-top: 10px;
    }
  }
  .liFirst{
    color:#fff;
    font-size: 16px;
    margin: 30px 0 20px;
  }
}
.right{
  padding: 5px 0;
  font-size: 14px;
  text-align: center;
  transform: scale(0.9);
  COLOR:#4b566b;
}
img{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
}
</style>